import type { ReactNode } from 'react';

import type { TColumnElement } from '@shared/dream-components';
import { ColumnElement } from '@shared/dream-components';

interface Props {
  node: TColumnElement;
  children: ReactNode | ReactNode[];
}

const Column = ({ node, children }: Props) => {
  return <ColumnElement element={node}>{children}</ColumnElement>;
};

export default Column;
